// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3slsD","right":"styles_right__1vAad"};